module.exports = __webpack_public_path__ + "static/media/03.110e665c.png";